module.exports = __webpack_public_path__ + "img/cute_handdrawn_2.72cd5e73.png";